import {ApplicationLang, PointCoords, TranslationBase} from '@domain/common/common';
import {ActivityDTO} from '@domain/activity/activity.dto';
import {HostDTO} from '@domain/host/host.dto';

export interface PlaceDTO {
  id: string;
  rank: PlaceRank;
  parent?: PlaceDTO | null;
  children?: PlaceDTO[] | null;
  code?: string | null;
  administrativeId?: string | null;
  langs?: ApplicationLang[] | null;
  coordinates?: PointCoords;
  translation?: PlaceTranslation | null;
  translations?: PlaceTranslation[];
}

export interface CreatePlaceRequest {
  rank: PlaceRank;
  parentId?: string | null;
  code?: string | null;
  coordinates?: PointCoords | null;
  administrativeId?: string | null;
  langs?: ApplicationLang[] | null;
  translations: PlaceTranslation[];
}

export interface PlaceTranslation extends TranslationBase {
  name: string;
}

export enum PlaceRank {
  Country = 'Country',
  Region = 'Region',
  District = 'District',
  Municipality = 'Municipality',
  Town = 'Town'
}

export interface PlaceStats {
  activities: ActivityDTO[];
  hosts: HostDTO[];
}
